import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { Bell, Heart, Home, MessageSquare, Plus, Search, Star, Wrench, Eye } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar"; // Kept for now, might be unused by NavbarLogout
import { Badge } from "../../_newprofiles/components/ui/Badge";
import { Button } from "../../_newprofiles/components/ui/Button"; // Kept for now
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card";
import styles from "./_HomeUserDashboard.module.css";
import SearchFormComponent from "./SearchFormComponent";
import FeaturedBusinesses from "./_FeaturedBusinesses"; // Import the new component
import NavbarLogout from "../../components/Navbar/navbar-logout";
import { jwtDecode } from 'jwt-decode';
import {  useNavigate } from 'react-router-dom';
// import Loader2 from '../../components/loader2'; // Placeholder if you have a loader

const HomePage404 = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [activeJobsData, setActiveJobsData] = useState([]);
  const [isLoadingActiveJobs, setIsLoadingActiveJobs] = useState(false);
  const [activeJobsError, setActiveJobsError] = useState(null);
  const [homeUserId, setHomeUserId] = useState(null);

  // State for Saved Businesses
  const [savedBusinessesData, setSavedBusinessesData] = useState([]);
  const [isLoadingSavedBusinesses, setIsLoadingSavedBusinesses] = useState(false);
  const [savedBusinessesError, setSavedBusinessesError] = useState(null);

  // State for Completed Jobs Count
  const [completedJobsCount, setCompletedJobsCount] = useState(0);
  const [isLoadingCompletedJobs, setIsLoadingCompletedJobs] = useState(false);
  const [completedJobsError, setCompletedJobsError] = useState(null);

  // State for Conversation Count
  const [conversationCount, setConversationCount] = useState(0);
  const [isLoadingConversationCount, setIsLoadingConversationCount] = useState(false);
  const [conversationCountError, setConversationCountError] = useState(null);


  useEffect(() => {

    //check to see if the user type is Home or business
    // if home , forward to / 
    // if business /newbusiness

    const myuserType = localStorage.getItem('userType');




    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUsername(decodedToken.UserName || 'User');
        setHomeUserId(decodedToken.nameid); // Set homeUserId here
      } catch (error) {
        console.error("Error decoding token:", error);
        setUsername('User');
        setActiveJobsError("Failed to identify user.");
      }
    } else {
      setUsername('User');
      setActiveJobsError("No user token found. Please log in.");
    }
  }, []);



  

  const getFirstName = (name) => {
    if (!name || name.toLowerCase() === 'user') return 'User';
    return name.split(' ')[0];
  };



  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            <div className={styles.headerLeft}>
              <div className={styles.logoContainer}>
                <Home className={styles.logoIcon} />
                <span className={styles.logoText}>Build Start</span>
              </div>
              <Badge variant="secondary" className={styles.homeOwnerBadge}>&nbsp;</Badge>
            </div>
            <NavbarLogout UserName={username} prefix={''} />
          </div>
        </div>
      </header>

      <div className={styles.container}>
        <div className={styles.mainContent}>
            <div className={styles.welcomeSection}>
              <h1 className={styles.welcomeTitle}>Welcome home, {getFirstName(username)}! 🏠</h1>
              <p className={styles.welcomeSubtitle}>Incorrect User Type - Please try logging out and logging back in.</p>
            </div>

        </div>
      </div>
    </div>
  );
};

export default HomePage404;
